import { App } from "@/shared/app";

export const managementApp: App = {
  title: "Organizacja",
  route: "organizacja",
};
